import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { InlineSearchComponent } from 'gung-list';
import { AuthService, Product } from 'gung-standard';
import { first } from 'rxjs';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'tylo-navbar-inline-search',
    templateUrl: './tylo-navbar-inline-search.component.html',
    styleUrls: ['./tylo-navbar-inline-search.component.css'],
    standalone: false
})
export class TyloNavbarInlineSearchComponent<T> extends InlineSearchComponent<T> {

  private currentItems: Product[] = [];

  protected override resolver = inject(ComponentFactoryResolver);
  protected override detector = inject(ChangeDetectorRef);
  protected override eRef = inject(ElementRef);
  protected override router = inject(Router);
  protected override route = inject(ActivatedRoute);
  protected authService = inject(AuthService);

  isTylo = environment.projectName === 'tylo';

  ngOnInit(): void {
    super.ngOnInit();
    this.renderItems$.subscribe(items => (this.currentItems = items as Product[]));
  }


  public onSearchSubmit(searchInput: {value: string}) {

    // Request from Tylo to instantly show product page when entered is clicked and only one item is in list.
    if (this.totalCount === 1 && this.currentItems.length === 1) {
      this.router.navigate(['/product', this.currentItems[0].id]);
      return;
    }

    this.showMoreProducts(searchInput);
  }

  public showMoreProducts({ value }) {

    if (this.isTylo) {
      // Request from Tylo (via support) to show the regular assortment view when searching. This broke the search for Helo so they should have the default behaviour.
      this.authService.getCurrentUser().pipe(first()).subscribe(user => {
        this.router.navigate(['/no-operation'], { skipLocationChange: true }).then(() => {
          this.router.navigate(['/categories', user.assortment], { queryParams: { search: 'DEFAULT__:__' + value } });
        });
      });
    } else {
      super.showMoreProducts({ value });
    }
  }
}
